/* Datos compartidos para Home (Models) y página Galería */
import img1 from '../images/1.jpg';
import img2 from '../images/2.jpg';
import img3 from '../images/3.jpg';
import img4 from '../images/4.jpg';
import img5 from '../images/5.jpg';
import img6 from '../images/6.jpg';
import img7 from '../images/7.jpg';
import img8 from '../images/8.jpg';
import img9 from '../images/9.jpg';
import img10 from '../images/10.jpg';
import img11 from '../images/11.jpg';
import img12 from '../images/12.jpg';
import img13 from '../images/13.jpg';
import img14 from '../images/14.jpg';
import img15 from '../images/15.jpg';
import img16 from '../images/16.jpg';
import img17 from '../images/17.jpg';
import img18 from '../images/18.jpg';
import img19 from '../images/19.jpg';
import img20 from '../images/20.jpg';
import img21 from '../images/21.jpg';
import img22 from '../images/22.jpg';
import img23 from '../images/23.jpg';
import img24 from '../images/24.jpg';
import img25 from '../images/25.jpg';
import img26 from '../images/26.jpg';
import img27 from '../images/27.jpg';

export const MODELS = [
  { id: 1, src: img1, tag: 'Rising Star', name: 'Alexandra', location: 'Studio Elite • Cali', category: 'lifestyle' },
  { id: 2, src: img2, tag: 'Elite Model', name: 'Marian', location: 'Studio Pro • Cali', category: 'main' },
  { id: 3, src: img3, tag: 'Featured', name: 'Alexandra', location: 'Webcam Specialist • Cali', category: 'main' },
  { id: 4, src: img4, tag: 'New Face', name: 'Anastasia', location: 'Platinum Model • Cali', category: 'new' },
  { id: 5, src: img5, tag: 'New Face', name: 'Leonela', location: 'Studio Elite • Cali', category: 'new' },
  { id: 6, src: img6, tag: 'New Face', name: 'Anastasia', location: 'Lifestyle Pro • Cali', category: 'lifestyle' },
  { id: 7, src: img7, tag: 'New Face', name: 'Marian', location: 'Studio Elite • Cali', category: 'new' },
  { id: 8, src: img8, tag: 'New Face', name: 'Arianna', location: 'Global Talent • Cali', category: 'influencer' },
  { id: 9, src: img9, tag: 'New Face', name: 'Angeles', location: 'Studio Elite • Cali', category: 'new' },
  { id: 10, src: img10, tag: 'New Face', name: 'Angeles', location: 'Studio Pro • Cali', category: 'lifestyle' },
  { id: 11, src: img11, tag: 'New Face', name: 'Arianna', location: 'Studio Elite • Cali', category: 'main' },
  { id: 12, src: img12, tag: 'New Face', name: 'Leonela', location: 'Lifestyle Pro • Cali', category: 'lifestyle' },
  { id: 13, src: img13, tag: 'New Face', name: 'Dalis', location: 'Studio Elite • Cali', category: 'new' },
  { id: 14, src: img14, tag: 'New Face', name: 'Isa', location: 'Studio Elite • Cali', category: 'new' },
  { id: 15, src: img15, tag: 'Featured', name: 'Isa', location: 'Studio Pro • Cali', category: 'main' },
  { id: 16, src: img16, tag: 'New Face', name: 'Michelle', location: 'Lifestyle Pro • Cali', category: 'lifestyle' },
  { id: 17, src: img17, tag: 'New Face', name: 'Michelle', location: 'Studio Elite • Cali', category: 'new' },
  { id: 18, src: img18, tag: 'Rising Star', name: 'Michelle', location: 'Studio Pro • Cali', category: 'lifestyle' },
  { id: 19, src: img19, tag: 'New Face', name: 'Dalis', location: 'Studio Elite • Cali', category: 'new' },
  { id: 20, src: img20, tag: 'New Face', name: 'Sofi', location: 'Lifestyle Pro • Cali', category: 'lifestyle' },
  { id: 21, src: img21, tag: 'Elite Model', name: 'Sofi', location: 'Studio Elite • Cali', category: 'main' },
  { id: 22, src: img22, tag: 'New Face', name: 'Salome', location: 'Studio Pro • Cali', category: 'new' },
  { id: 23, src: img23, tag: 'New Face', name: 'Salome', location: 'Lifestyle Pro • Cali', category: 'lifestyle' },
  { id: 24, src: img24, tag: 'Featured', name: 'Salome', location: 'Studio Elite • Cali', category: 'main' },
  { id: 25, src: img25, tag: 'New Face', name: 'Rossel', location: 'Studio Pro • Cali', category: 'new' },
  { id: 26, src: img26, tag: 'New Face', name: 'Rossel', location: 'Lifestyle Pro • Cali', category: 'lifestyle' },
  { id: 27, src: img27, tag: 'Rising Star', name: 'Rossel', location: 'Studio Elite • Cali', category: 'influencer' },
];

export const GALLERY_CATEGORIES = [
  { id: 'all', label: 'Todos' },
  { id: 'main', label: 'Main Board' },
  { id: 'new', label: 'Nuevos Rostros' },
  { id: 'lifestyle', label: 'Lifestyle' },
  { id: 'influencer', label: 'Influencers' },
];

export const SHORT_FILMS = [
  {
    id: 1,
    title: 'The Velvet Hour',
    subtitle: 'Imaan Hammam • Studio A Session',
    thumbnail: 'https://lh3.googleusercontent.com/aida-public/AB6AXuBcL5Vq8SaTToM9gWgJ4d9kuOz8EGqiihShYcN44EArN7kwCQyvT9CZu8r9ZdSFP309Qw7LUAEzRho7dDgNYeZ7K8Lwe0GRbMQcSbVWs_pfFh-nhqOz71pAvSnK3rASyrcymfhYOSwUfbVLpHJ4jVw2jMQl2GjE2lupMMrojACWPlVxTJi1qC-jkvixyp0lDLpwxjoscBXtbmVHoe46-cgX1jB3Z_A0qGNIuvkuQs9EIRBDc7AGKQmOWRwM1UqgqczZTj3Ey9VDpXnz',
    videoUrl: null,
  },
  {
    id: 2,
    title: 'Metropolis Noir',
    subtitle: 'AW24 Collection • Lifestyle Film',
    thumbnail: 'https://lh3.googleusercontent.com/aida-public/AB6AXuDb6-i75xrm91J38dxWQtoOUQUtZcDlWHJZmkn50L_MxSwcpvlUEZIx5EzmN6dP62MfhYDgVaGBIkNlcYOP46EDf0xuC_alPhjTi8n2Thfr-KbNKbkuI0UhqbCQ_SH_SgiNXI5cWDFbpdwdHmTCAegHmHMs500WtvaRYreia9iOWr-6gea4S5lFPx9cLnVzpFurtQ0POPCSQO684ABWOvmfKdGiCZmTRC0Mv-TIlocd48DYnlara_WuRmZ235r6oTinDpEXMX2EHHqP',
    videoUrl: null,
  },
];
